import { IBios } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@/shared';
import { StoreBaseImplementation } from '@/shared/classes/store-base-implementation';

interface IBiosState {
  bioOrder: Partial<IBios>[]
}

const adminGatewayResourcePath: string = '/website-api/sites/:param/bios';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {};
const defaultGetSingleFilters: IQueryCommandOptions = {};

const base = new StoreBaseImplementation<IBios>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced, // 'bios/'

  state: {
    ...base.state,
    bioOrder: {} as IBiosState,
  },

  getters: {
    ...base.getters,
    getOrder(state: IBiosState) {
      return state.bioOrder;
    },
  },

  mutations: {
    ...base.mutations,
    setOrder(state: IBiosState, payload: Partial<IBios>[]) {
      state.bioOrder = payload;
    },
  },

  actions: {
    ...base.actions,
  },
};
